<script setup lang="ts">
const modelValue = defineModel<Game.Mode>('modelValue', {
  default: 'demo',
});

const isToggleChecked = ref<boolean>(false);

function onCheckboxChanges(isChecked: boolean) {
  isToggleChecked.value = isChecked;

  modelValue.value = isChecked ? 'real' : 'demo';
}

watchEffect(() => {
  isToggleChecked.value = modelValue.value === 'real';
});
</script>

<template>
  <div :class="$style.demoToggle">
    <span>Modo Demo</span>

    <BaseFormToggle
      :class="$style.toggle"
      v-bind="$attrs"
      :model-value="isToggleChecked"
      @update:model-value="onCheckboxChanges"
    />

    <span>Modo Real</span>
  </div>
</template>

<style module lang="postcss">
.demoToggle {
  @apply flex items-center gap-3 border-r border-texts/20 border-solid pr-6;

  span {
    @apply whitespace-nowrap text-xs font-semibold text-texts;
  }

  .toggle {
    @apply -mb-0.5;
  }
}
</style>
